export default __webpack_public_path__ + "static/media/V230_SOV.540c0a92.pdf";